// import ReactDOM from 'react-dom'
import {createRoot} from "react-dom/client"
// import store from './store/index'
// import { Provider } from 'react-redux'
// import App14 from './App14'
import BaseRouter from './router/index.jsx'
// react17 写法
// ReactDOM.render(arg1,arg2)
// ReactDOM.render(<App14/>,document.getElementById('root'))
// React 18写法
const container=document.getElementById('root')
const root=createRoot(container)
root.render(
  //  <Provider store={store}>
      <BaseRouter />
  // </Provider>
  )
// 模拟试用useEffect 销毁周期
// setTimeout(() => {
//   root.render(<input type="text"/>)

// }, 1000);